export default {"src":"/_next/static/media/nature-relaxation.colour.17de358e.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};